import { Box, Grid, Typography } from '@material-ui/core';
import CardsForms from '../steps/Step4/organisms/CardsForms/CardsForms';
import { billingAddress } from '../constants/selectOptions';
import useStyles from '../steps/Step1/styles';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import React, { useEffect } from 'react';
import AdditionalExpenseSummary from './AdditionalExpenseSummary';
import TipsSection from '../steps/Step4/molecules/TipsSection';
import FormOperator from '../components/FormOperator/FormOperator';
import Accreditation from "../components/Accreditation/Accreditation";

const AdditionalExpensePaymentStep = (
  {
    apiData,
    handleSubmit,
    cards,
    tipsValue
  }
) => {
  const classes = useStyles();

  const {control, register, setValue, getValues, formState} =
    useFormContext();
  const {fields, append, remove} = useFieldArray( {
    control,
    name: 'cards'
  } );

  const splitPaymentValue =
    useWatch( {name: 'splitPayment'} ) || getValues( 'splitPayment' );
  const currentValues = useWatch( {name: 'cards'} ) || getValues( 'cards' );
  const confirmTermsValue =
    useWatch( {name: 'confirmTerms'} ) || getValues( 'confirmTerms' );
  const acceptTipsValue =
    useWatch( {name: 'acceptTips'} ) || getValues( 'acceptTips' );
  const manualSplitValue = useWatch({name: 'manualSplit'}) || getValues('manualSplit')
  const isForceManualSplitValue = useWatch({name: 'isForceManualSplit'}) || getValues('isForceManualSplit')



  const defaultCardValues = {
    cardNumber: '',
    cardHolderName: '',
    expirationDate: null,
    cvv: '',
    country: '',
    city: '',
    state: '',
    street: '',
    postalCode: '',
    cardHolderEmail: '',
    cardPhoneNumber: '',
    billingAddress: 'default'
  };

  const addNewCard = () => {
    append({
      ...defaultCardValues,
      card_id: `card_${fields.length + 1}`
    });
  };

  useEffect( () => {
    if (splitPaymentValue === true && fields.length > 1) {
    } else if (splitPaymentValue === true && fields.length === 1) {
      addNewCard();
    } else if (currentValues.length > 1) {
      setValue( 'cards', [fields[0]] );
    }
  }, [splitPaymentValue] );

  return (

    <Grid container>
      <Grid item xs={12} md={7} className={classes.mainForm}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mb={4}
        >
          <Typography variant="h3" align="center">
            {`Dear ${apiData.customer?.first_name} ${apiData.customer?.last_name},`}
          </Typography>
          <Typography variant="body1" align="center">
            Reaching out in regard to the <strong>{apiData.destination}</strong> trip
          </Typography>

        </Box>

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          mb={4}
          px={2}
        >
          <Typography variant="body1" align="center">
            {apiData.remark}
          </Typography>
        </Box>

        <Box
          mb={2.5}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          className={classes.formHeader}
        >

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.headerText}
          >
            <Typography variant="h1" align="center">
              Payment information
            </Typography>
            <Typography variant="body1" align="center">
              All transactions are secure and encrypted
            </Typography>
          </Box>
        </Box>
        <Box className={classes.cardForm}>
          <CardsForms
            fields={fields}
            currentValues={cards}
            defaultCardValues={defaultCardValues}
            addNewCard={addNewCard}
            billingAddress={billingAddress}
            splitPaymentValue={splitPaymentValue}
            remove={remove}
            setValue={setValue}
            formType={apiData.result ? 'approve' : ''}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={5}
        className={classes.secondaryForm}
        justifyContent="flex-start"
        alignItems="center"
      >

        <TipsSection
          operatorInfo={apiData?.operatorInfo}
          register={register}
          defaultTips={tipsValue}
          setValue={setValue}
          acceptTips={acceptTipsValue}
        />

        <AdditionalExpenseSummary
          classes={classes}
          apiData={apiData}
          confirmTerms={confirmTermsValue}
          handleNext={handleSubmit}
          cards={cards}
          splitPaymentValue={splitPaymentValue}
          register={register}
          setValue={setValue}
          cardsAmmount={apiData?.result?.cardsAmmount}
          acceptTipsValue={acceptTipsValue}
          tipsValue={tipsValue}
          manualSplitValue={manualSplitValue}
          isForceManualSplitValue={isForceManualSplitValue}
          previewMode={false}
        />

        <Box mt={4}>
          <FormOperator operatorInfo={apiData?.operatorInfo}/>
        </Box>

        <Box width={1}>
            <Accreditation />
        </Box>
      </Grid>
    </Grid>
  );
}

export default AdditionalExpensePaymentStep
